import type { OilPhaseVolumeFactorBoCalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const oilPhaseVolumeFactorBoCalculator: OilPhaseVolumeFactorBoCalculator =
  params => {
    const {
      gasSpecificGravity,
      temperatureInRankine,
      inSituPressurePSIA,
      oilAPI,
      oilSpecificGravity,
      temperatureF,
      bubblePointPressurePSIA,
      gasOilRatio
    } = params;

    const { gasSGat100psigSeparatorYg100, cnLtApi30, cnGtApi30 } =
      solutionGasRsoCalculator(params);

    // D270: =0.05958*D234*(D230**0.7972)*(J18**1.0014)
    const solutionGasatPbRsb_lte_30 =
      0.05958 *
      cnLtApi30 *
      gasSGat100psigSeparatorYg100 ** 0.7972 *
      bubblePointPressurePSIA ** 1.0014;

    // D272: =0.0315*D240*(D230**0.7587)*(J18**1.0937)
    const solutionGasatPbRsb_gt_30 =
      0.0315 *
      cnGtApi30 *
      gasSGat100psigSeparatorYg100 ** 0.7587 *
      bubblePointPressurePSIA ** 1.0937;

    // D274: =IF(D27>30,D272,D270)
    let solutionGasPbRsb;
    if (oilAPI <= 30) {
      solutionGasPbRsb = solutionGasatPbRsb_lte_30;
    } else {
      solutionGasPbRsb = solutionGasatPbRsb_gt_30;
    }
    solutionGasPbRsb =
      solutionGasPbRsb > gasOilRatio ? gasOilRatio : solutionGasPbRsb;

    // D276: =(D274**0.755)*(D230**0.28)*(D17**-1.5)+0.45*D4
    const F =
      solutionGasPbRsb ** 0.755 *
        gasSGat100psigSeparatorYg100 ** 0.28 *
        oilSpecificGravity ** -1.5 +
      0.45 * temperatureF;

    // D278: =0.98496+0.0001*D276**1.5
    const oilFormationVolumeFactorSatBo = 0.98496 + 0.0001 * F ** 1.5;
    // D280: =(-1433+5*D274+17.2*D15-1180*D8+12.61*D7)/((10**5)*D3)
    const oilCompressibilityUnSatCo =
      (-1433 +
        5 * solutionGasPbRsb +
        17.2 * temperatureInRankine -
        1180 * gasSpecificGravity +
        12.61 * oilAPI) /
      (10 ** 5 * inSituPressurePSIA);
    // D282: =D278*EXP(D280*(J18-D3))
    const oilFormationVolumeFactorUnSatBo =
      oilFormationVolumeFactorSatBo *
      Math.exp(
        oilCompressibilityUnSatCo *
          (bubblePointPressurePSIA - inSituPressurePSIA)
      );
    return {
      solutionGasPbRsb,
      F,
      oilCompressibilityUnSatCo,
      oilFormationVolumeFactorSatBo,
      oilFormationVolumeFactorUnSatBo,
      cnGtApi30,
      gasSGat100psigSeparatorYg100,
      bubblePointPressurePSIA,
      solutionGasatPbRsb_lte_30,
      solutionGasatPbRsb_gt_30
    };
  };
